import { render } from "./ItemAccordion.vue?vue&type=template&id=58999dc0"
import script from "./ItemAccordion.vue?vue&type=script&lang=js"
export * from "./ItemAccordion.vue?vue&type=script&lang=js"

import "./ItemAccordion.vue?vue&type=style&index=0&id=58999dc0&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__